import { connect } from 'react-redux'
import { compose, withHandlers, lifecycle, withState } from 'recompose'
import { bindActionCreators } from 'redux'


import * as UserActions from 'app/modules/user/actions'
import * as UserSelectors from 'app/modules/user/selectors'


import IndividualConversationLimit from './component'


const mapStateToProps = (state, props) => ({
  convoLimitForUser: UserSelectors.convoLimitForUser(state, props.user.id),
  convoLimitForUserLoading: UserSelectors.convoLimitForUserLoading(state, props.user.id),
  convoLimitForUserNeverLoaded: UserSelectors.convoLimitForUserNeverLoaded(state, props.user.id),
  convoLimitForUserSavedSuccess: UserSelectors.convoLimitForUserSavedSuccess(state, props.user.id),
})


const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchConvoLimitForUser: UserActions.fetchIndividualUserConvoLimit,
      saveConvoLimitForUser: UserActions.updateIndividualUserConvoLimit,
    },
    dispatch
  ),
})


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('hasConvoLimit', 'setHasConvoLimit', props => !!props.convoLimitForUser),
  withState('localConvoLimit', 'setLocalConvoLimit', props => props.convoLimitForUser || 0),
  lifecycle({
    componentDidMount() {
      if (this.props.convoLimitForUserNeverLoaded) {
        this.props.actions.fetchConvoLimitForUser({ userId: this.props.user.id })
      }
    },
    componentDidUpdate(prevProps) {
      if (prevProps.convoLimitForUser !== this.props.convoLimitForUser) {
        this.props.setHasConvoLimit(!!this.props.convoLimitForUser)
        this.props.setLocalConvoLimit(this.props.convoLimitForUser)
      }
    }
  }),
  withHandlers({
    onToggleConvoLimit: props => (e) => {
      const { setHasConvoLimit } = props
      setHasConvoLimit(e.target.checked)
    },
    onChangeConvoLimit: props => (e) => {
      const { setLocalConvoLimit } = props
      setLocalConvoLimit(e.target.value)
      // TODO: do some action here
    },
    onSave: props => () => {
      const { actions } = props
      actions.saveConvoLimitForUser({ userId: props.user.id, remove: !props.hasConvoLimit, limit: props.localConvoLimit })
    }
  }),
)(IndividualConversationLimit)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/IndividualConversationLimit/index.js